import type { DashboardOverview } from '../types';

export function sameDashboardOverview(a: DashboardOverview, b: DashboardOverview): boolean {
  try {
    return JSON.stringify(a) === JSON.stringify(b);
  } catch {
    return false;
  }
}
